// extracted by mini-css-extract-plugin
module.exports = {"MoreArticles":"MoreArticlesButton_MoreArticles__1ayt3","Button":"MoreArticlesButton_Button__cT3Yk","Image":"MoreArticlesButton_Image__3t2v8"};